import { Box, Column, FlexBox, SelectionSetInput, SelectionSetLabel, Typography } from '@vp/swan';
import { Currency } from '@99designs/design-services-common';
import { __ } from '@99designs/i18n';
import { ProductOptionPrice } from '../ProductOptionPrice';

type OptionInputProps = {
    title: string;
    value: string;
    icon?: JSX.Element;
    price: number;
    currency: Currency;
    loading: boolean;
    disabled?: boolean;
};

export const OptionInput = ({
    title,
    value,
    icon,
    price,
    currency,
    loading,
    disabled,
}: OptionInputProps) => {
    return (
        <Column span={6} spanXs={6} key={value}>
            <SelectionSetInput value={value} disabled={disabled}>
                <SelectionSetLabel>
                    <FlexBox gap={5}>
                        {icon && <FlexBox alignItems={'center'}>{icon}</FlexBox>}
                        <Box>
                            <Typography fontSkin="body-standard-bold">{title}</Typography>
                            <Typography fontSkin="body-small" textColor="subtle">
                                <ProductOptionPrice
                                    price={price}
                                    currency={currency}
                                    loading={loading}
                                    disabled={disabled}
                                />
                            </Typography>
                        </Box>
                    </FlexBox>
                </SelectionSetLabel>
            </SelectionSetInput>
        </Column>
    );
};
